const Styles = {
  container: {
    position: "relative",
  },

  dropDownIcon: {
    position: "absolute",
    top: 20,
    right: "10%",
  },

  arrowDropDown: {
    color: "rgba(143, 146, 161, 0.4)",
    fontSize: "medium",
  },

  card: {
    position: "absolute",
    maxHeight: 300,
    overflow: "auto",
    width: "100%",
    zIndex: 9999,
  },

  typography: {
    padding: "5px 15px",
    borderBottom: "1px solid #f1f1f1",
    margin: "5px",
  },

  spanAddress: {
    fontWeight: 500,
  },

  spanAddress2: {
    marginLeft: 5,
  },

  inputField: {
    width: "100%",
    marginTop: 10,
    marginBottom: 10,
  },
};
export default Styles;
